<template>
  <div class="third">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-content">APP启动配置</span>
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="Preservation()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form
        style="display:inline-block;width:60%;float:left"
        @validate="validateValue"
        :show-message="false"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="86px"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-list my-from-label">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="86px">
                <el-form-item class="first" label="启动图" prop="icon">
                  <el-upload
                    style="display: inline-block;margin-left: 10px;margin-top:20px;"
                    class="list-upload-img my-upload-qdt"
                    :limit="9"
                    action="/api/blade-platform/serviceInfo/upload"
                    :show-file-list="false"
                    :on-success="handleSuccess"
                    :data="{fileType:1}"
                    :on-error="hadleError"
                    :before-upload="beforeUpload"
                    accept=".jpg, .jpeg, .png, .gif"
                    list-type="picture-card"
                    :class="{hide:hideUpload}"
                    >
                    <i class="el-icon-plus"></i>
                    <div class="list-upload-title">点击上传</div>
                    <div
                      slot="tip"
                      class="list-upload-tip"
                    >10M以内，建议大小1334x750像素，支持扩展名.png、.jpg、.jpeg、gif.</div>
                  </el-upload>
                  <el-radio-group v-model="radio" style="display:inline-block;float: left;width:600px;">
                    <div style="display:inline-block;float: left;clear:both">
                      <div
                        class="change_dispaly"
                        v-for="(item,index)  in fileList"
                        :key="index"
                        style="display: inline-block;margin-left: 10px;position: relative;"
                      >
                        <img :src="item.url" style="width:100px;height:100px;border-radius: 6px;margin-top:20px" />
                        <el-radio
                          :label="item.url"
                          style="position: absolute;top:20px;right:-42px;z-index:9"
                        >&nbsp;</el-radio>
                        <div
                          class="change_div"
                          style="position: absolute;top:20px;left:0;width:100px;height:100px;border-radius: 6px;background-color: #000;opacity: 0.5;color: white; display:none"
                        >
                          <i
                            class="el-icon-zoom-in"
                            style="font-size: 20px;margin-top:42%;margin-left:30%"
                            @click="Seedata(item.url)"
                          ></i>
                          <i
                            @click="deleteData(index)"
                            class="el-icon-delete"
                            style="font-size: 20px;margin-left:5px"
                          ></i>
                        </div>
                      </div>
                    </div>
                    </el-radio-group>
                  
                </el-form-item>
                <el-form-item  label="访客模式" prop="chooseGuest" style="margin-top: 40px;">
                  <el-radio-group v-model="ruleForm.chooseGuest">
                    <el-radio :label="'1'">开启</el-radio>
                    <el-radio :label="'0'">关闭</el-radio>
                  </el-radio-group>
                  <div style="font-size:12px  ;color:#aeaeb4">开启访客模式后，用户可在未登录状态下，进入APP查看校友圈及服务模块的部分内容</div>
                </el-form-item>
                 <el-form-item  label="应用唯一标识" prop="WXAppid">
                  <el-input
                      class="list-input"
                      :maxlength="30"
                      v-model.trim="ruleForm.WXAppid"
                      placeholder="请输入"
                    ></el-input>
                  <div style="font-size:12px  ;color:#aeaeb4">如APP有微信小程序或微信公众号服务，请正确填写此参数，否则APP端无法打开微信小程序或微信公众号</div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right">
        <img class="phon-right-img" src="@/assets/qdt.gif" alt="">
      </div>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
// import { addxuexiao, selectxuexiao } from "@/api/baseData/xuexiao";
import {
  getAppStartImage,
  deleteStartImage,
  saveAppStartImage
} from "@/store/appconfig/adhibitionJPG"; //我的

export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      hideUpload: false,
      radio: "",
      radio_img: "", //选择图片
      countNum: 1, //用于显示第一个错误
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // },
      ], // 上传文件列表
      pointList: [],
      rules: {
        icon: [
          { required: true, message: "请添加学校启动图", trigger: "blur" }
        ],
        chooseGuest: [
          { required: true, message: "请选择学校访客模式配置", trigger: "blur" }
        ],
        WXAppid: [
          { required: false, message: "请填写应用唯一标识", trigger: "blur" }
        ]
      },
      ruleForm: {
        icon: "",
        chooseGuest: "1",
        WXAppid: ""
      },
      fileListlength: 0,
      upload_img: [] //上传图片数据
    };
  },
  created() {
    this.getAppStartImageFN();
  },
  watch: {
    'fileList.length'() {
      this.fileList.length > 8 ? this.hideUpload = true:this.hideUpload = false
    }
  },
  methods: {
    //重置
    Reset() {
      this.getAppStartImageFN();
    },
    //保存
    Preservation() {
      try {
        this.upload_img = []
        this.fileList.forEach(item => {
          this.upload_img.push(item.url);
        });
        const params = {
          appUploadImgVO: {
            file: this.upload_img.join(), //新上传的图片地址以逗号隔开
            selectImageUrl: this.radio //选择作为启动图的URL地址
          },
          chooseGuest: this.ruleForm.chooseGuest,
          WXAppid: this.ruleForm.WXAppid
        };
        console.log('params',params)
        saveAppStartImage(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.getAppStartImageFN();
            this.$message.success("操作成功");
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //单选
    radioFN(item, index) {
      // console.log("进来了");
      // this.radio = index;
      index == this.radio ? (this.radio = "") : (this.radio = index);
      // this.radio === this.radio ? "" : index;
      if (this.radio == "") {
        this.radio_img = "";
      } else {
        this.radio_img = item.url;
      }
      console.log(this.radio);
      console.log(this.radio_img);
    },
    //删除图片
    deleteData(index) {
      // console.log(item);
      // if (item.id) {
      //   try {
      //     const params = { id: item.id };
      //     deleteStartImage(params).then(res => {
      //       const data = res.data;
      //       if (data.status === 1000) {
      //         this.fileList.forEach(data => {
      //           if (data.url == item.url) {
      //             this.fileList.splice(this.fileList.indexOf(item), 1);
      //           }
      //         });
      //         if (this.fileList.length < 9) {
      //           this.hideUpload = false;
      //         }else{
      //           this.hideUpload = true;
      //         }
      //       }else {
      //       this.$message({
      //         type: "error",
      //         message: data.msg
      //       });
      //     }
      //     });
      //   } catch (err) {
      //     console.log(err);
      //   }
      // } else {
      //   this.fileList.forEach(data => {
      //     if (data.url == item.url) {
      //       this.fileList.splice(this.fileList.indexOf(item), 1);
      //     }
      //     if (this.fileList.length < 9) {
      //       this.hideUpload = false;
      //     }
      //   });
      // }
      // console.log('this.fileList', this.fileList)
      // console.log('this.fileList', item)
      // const picIndex = this.fileList.findIndex(file => {
      //   return file.url === item.url
      // })
      // if(picIndex !== -1) {
        
      // }
      if(this.fileList[index].url === this.radio) {
        if(this.fileList.length >= 1) {
          this.radio = this.fileList[0].url
        }else{
          this.radio = ''
        }
      }
      this.fileList.splice(index,1)
    },
    //查看图片
    Seedata(item) {
      console.log("查看");
      this.dialogImageUrl = item;
      this.dialogVisible = true;
    },
    //获取默认图片
    getAppStartImageFN() {
      try {
        getAppStartImage().then(res => {
          const data = res.data;
          console.log("获取到了默认图", data);
          if (data.status === 1000) {
            this.fileList = data.result.startImage
            this.fileList.forEach(imgData => {
              imgData['url'] = imgData.picUrl
              if(imgData.status === 1) {
                this.radio = imgData.picUrl
              }
            })
            this.ruleForm.chooseGuest = data.result.chooseGuest
            this.ruleForm.WXAppid = data.result.WXAppid
            // this.fileList.forEach(item => {
            //   item.url = item.picUrl;
            //   if (item.status == 1) {
            //     console.log("进来了");
            //     this.radio = this.fileList.indexOf(item) + 1;
            //     this.radio_img = item.picUrl;
            //   }
            // });
            // if(this.fileList.length) {
            //   this.radio = this.fileList[0].picUrl
            // }
            // this.fileList.length >= 9?this.hideUpload = true:this.hideUpload = false
            // if (this.fileList.length >= 9) {
            //   this.hideUpload = true;
            // }
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 图片上传成功成功
    handleSuccess(file) {
      // console.log(file);
      this.fileList.push({ url: file.data[0].oUrl, status: 9 });
      if(this.fileList.length === 1) {
        this.radio = this.fileList[0].url
      }
      // this.fileList.length >= 9 ? this.hideUpload = true : this.hideUpload = false 
      // console.log(" this.fileList", this.fileList);
    },
    // 上传之前
    beforeUpload(file) {
      console.log(file);
      let typeList=["image/jpeg","image/png","image/jpg","image/gif"]
      if(typeList.indexOf(file.type)==-1){
         this.$message.error("文件格式错误，请重新上传!");
         return false;
      }
      // if (this.fileList.length >= 8) {
      //   this.hideUpload = true;
      // }
      const imgsize = file.size / 1024 / 1024 < 10;
      if (!imgsize) {
        this.$message.error("上传图片最大10M, 请重新上传!");
        return false;
      }
    },
    // 上传失败
    hadleError(err) {
      // console.log("2");
      this.$message.error(err);
    },
    //---------------------------------------------------------------------------------------------------
    //获取学校详情
    selectinfo() {
      //   try {
      //     const params = {
      //       eduSchoolInfo: {
      //         tenantId: this.$store.state.user.tenantId //大学id  （当前登录用户id）
      //       }
      //     };
      //     selectxuexiao(params).then(res => {
      //       const data = res.data;
      //       console.log("这是学校管理的详情接口", data);
      //       if (data.status === 1000) {
      //         this.ruleForm = data.result;
      //         let arr = [];
      //         arr = this.ruleForm.administrativeArea.split(",");
      //         this.ruleForm.administrativeArea = arr;
      //         console.log("这是学校管理的详情数据", this.ruleForm);
      //       }
      //     });
      //   } catch (err) {
      //     console.log(err);
      //   }
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            return this.save();
          } else {
            return false;
          }
        });
      });
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //新增/修改学校信息
    save() {
      //   try {
      //     let administrativeArea = "";
      //     if (this.ruleForm.administrativeArea !== []) {
      //       administrativeArea = this.ruleForm.administrativeArea.join(",");
      //     }
      //     const params = {
      //       eduSchoolInfo: {
      //         tenantId: this.$store.state.user.tenantId, //大学id  (当前登录用户处取得  值为当前登录用户ID)
      //         schoolId: this.ruleForm.schoolId, //学校代码  ruleForm.schoolNum
      //         schoolName: this.ruleForm.schoolName, //学校名称  ruleForm.schoolNam
      //         englishName: this.ruleForm.englishName, //英文名称  ruleForm.Ename
      //         address: this.ruleForm.address, //地址         ruleForm.Dz
      //         postcode: this.ruleForm.postcode, //邮编       ruleForm.YB
      //         administrativeArea: administrativeArea, //行政区域   ruleForm.XingZ
      //         foundingYear: this.ruleForm.foundingYear, //建校年月      ruleForm.JXDate
      //         schoolAnniversary: this.ruleForm.schoolAnniversary, //校庆日    ruleForm.XQdate
      //         presidentName: this.ruleForm.presidentName, //校长姓名      ruleForm.XiaoZ
      //         presidentId: this.ruleForm.presidentId, //校长工号      ruleForm.XiaoZ
      //         director: this.ruleForm.director, //党建负责人     ruleForm.DJpeople
      //         directorId: this.ruleForm.directorId, //党建负责人工号    ruleForm.DJpeople
      //         tel: this.ruleForm.tel, //学校联系电话      ruleForm.schoolPho
      //         email: this.ruleForm.email, //学校电子邮箱     ruleForm.schoolEmai
      //         homeUrl: this.ruleForm.homeUrl //主页地址        ruleForm.ZYplace
      //       }
      //     };
      //     addxuexiao(params).then(res => {
      //       const data = res.data;
      //       console.log("这是学校管理新增/编辑接口", data);
      //       if (data.status === 1000) {
      //         this.selectinfo();
      //         this.$message.success("保存成功");
      //       }else{
      //          this.$message.error(data.msg);
      //       }
      //     });
      //   } catch (err) {
      //     this.$message.error(err);
      //     console.log(err);
      //   }
    },
    //表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    async resetForm(formName) {
      // this.ruleForm.administrativeArea = [];
      // this.ruleForm.createTime = "";
      // this.ruleForm.director = "";
      // this.ruleForm.directorId = "";
      // this.ruleForm.foundingYear = "";
      // this.ruleForm.presidentId = "";
      // this.ruleForm.presidentName = "";
      // this.ruleForm.schoolAnniversary = "";
      // this.ruleForm.updateTime = "";
      // console.log("重置", this.ruleForm);
      await this.selectinfo();
      this.$refs[formName].resetFields();
    },
    // 关闭预览弹窗
    closePreview() {
      this.dialogVisible = false;
    },
    //行政区域选中节点
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>

<style lang="scss">
.my-upload-qdt{
  // width: 100px;
  float: left;
  position: relative;
  .el-upload--picture-card{
    float: left;
    overflow: hidden;
  }
  .list-upload-tip{
    width: 400px;
    position: absolute;
    left: 0;
    bottom: -25px;
  }
}
.my-from-label {
  .el-form {
    .first {
      .el-form-item__label:nth-child(1) {
        padding-top: 15px!important;
      }
    }
  }

}
.change_dispaly:hover .change_div {
  display: block !important;
}
// .change_div:hover {
// display: block
// border: 1px solid red;
// }
.slideshow {
  .fileDisabled {
    .el-upload--picture-card {
      display: none;
    }
  }
  .fileleft {
    overflow: hidden;
    .el-upload--picture-card {
      float: left !important;
      margin-right: 8px !important;
    }
  }
}
.hide .el-upload--picture-card {
  // display: none;
  opacity: 0;
}
</style>
